import { render, staticRenderFns } from "./LgFinderPagePessoaModal.vue?vue&type=template&id=2220a846"
import script from "./LgFinderPagePessoaModal.vue?vue&type=script&lang=js"
export * from "./LgFinderPagePessoaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports